import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    // name: "index",
    // component: () => import("@/views/index.vue"),
    name: "backStage",
    component: () => import("@/views/backStageIndex.vue"),
  },
  {
    path: "/backStage",
    name: "backStage",
    component: () => import("@/views/backStageIndex.vue"),
  },
  {
    path: "/index",
    name: "index",
    component: () => import("@/views/index.vue"),
  },
];

export default new VueRouter({
  mode: "hash",
  scrollBehavior: () => ({ y: 0 }),
  routes,
});
